// import * as React from "react";
// import { Navigate } from "react-router-dom";

// export type ProtectedRouteProps = {
//   authenticationPath: string;
//   outlet: React.ReactNode;
// };

// export default function ProtectedRoute({
//   authenticationPath,
//   outlet,
// }: ProtectedRouteProps) {
//   const accessToken = localStorage.getItem("access_token");

//   if (accessToken) {
//     return <>{outlet}</>; // Wrap in fragment if outlet can be a string or array
//   } else {
//     return <Navigate to={authenticationPath} replace />;
//   }
// }


import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../redux/store";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ authenticationPath = "/login" }: any) => {
  const reduxStep = useSelector((state: RootState) => state.auth.step)
  const isAuth = localStorage.getItem("access_token"); // or use Redux/AuthContext
  const isRegistering = localStorage.getItem("is_registering") === "true";
  const pathname = useLocation().pathname;
  const user = useSelector((state: RootState) => state.user.info)
  console.log("pathname", pathname);
  console.log("isAuth", isAuth);
  console.log('isRegistering==>>', isRegistering)
  const navigate = useNavigate();
  // if (!isAuth) {
  //   return <Navigate to={authenticationPath} replace />;
  // } 

  // 1. If logged in and trying to go to login/register, force them to dashboard
  //  if (isAuth && isRegistering && user?.status == "APPROVED" && (pathname === "/login" || pathname === "/register" || pathname === "/")) {
  //   return <Navigate to="/dashboard" replace />;
  // }


  if (isAuth) {
    if (
      isRegistering &&
      user?.status === "APPROVED" &&
      (pathname === "/login" || pathname === "/register" || pathname === "/")
    ) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  // 2. If NOT logged in and trying to access private routes
  if (!isAuth && pathname !== "/login" && pathname !== "/register") {
    return <Navigate to={authenticationPath} replace />;
  }

  // 3. Otherwise, render the child (Login, Register, or Main Dashboard)
  return <Outlet />;
};

export default ProtectedRoute;
